import LocalStorageService from 'web-app/services/local-storage';
import IntercomService from 'web-app/services/intercom';
import ENV from 'web-app/config/environment';
import LoginsApi from 'web-app/api/logins-api';
import store from 'web-app/react/redux/store';
import {getBaseUrl} from 'web-app/util/location';
import {TrackingEvents} from 'web-app/util/famlytics/events';
import * as Famlytics from 'web-app/util/famlytics';
import * as SessionSelectors from 'web-app/react/session/selectors';
import {ACCESS_TOKEN_KEY} from 'web-app/util/access-token-helpers';
import {purgeErrorLog} from 'web-app/react/routes/error-log/helpers';

export const logOut = (errorState?: string, invokeRemoteLogoutProcedure = true, wasAutoLogout = false) => {
    // Tracking event fired when user is automatically logged out during finance onboarding flow.
    // We want to track why users might not be completing the flow
    // Remove this event when the analysis is done to avoid unnecessary Mixpanel charges
    if (wasAutoLogout && window.location.href.includes('financeOnboarding')) {
        Famlytics.track(TrackingEvents.INACTIVE_USER_LOGGED_OUT);
    }

    LocalStorageService.clearKey(ACCESS_TOKEN_KEY);

    IntercomService.shutdown();

    if (!SessionSelectors.isLoggedIn(store.getState())) {
        return;
    }

    Famlytics.flush();
    purgeErrorLog();

    const finalCleanup = () => {
        // We refresh either way
        const errorParam = errorState ? `?error=${errorState}` : '';
        window.location.href = getBaseUrl() + errorParam;
    };

    // Wait a bit before starting the logout process to give Famlytics some time to send the remaining events.
    // 500 ms hits the "sweet-spot" between getting reassurance that the events will be sent while still not
    // making the user wait too long before we actually log out.
    setTimeout(() => {
        if (invokeRemoteLogoutProcedure) {
            LoginsApi.logOut(store.getState().notifications.deviceToken, ENV.APP.appKind, wasAutoLogout).finally(
                finalCleanup,
            );
        } else {
            finalCleanup();
        }
    }, 500);
};
